export default __webpack_public_path__ + "static/media/badges-100@2x.67f7e96c.png";